import React, { useRef } from 'react';
import close from '../Components/Images/x-close.png';

const ConfirmLogOut = ({ onLogOut, setOnLogOut }) => {
    const logOutModel = useRef();

    const handleRefClick = (e) => {
        if (logOutModel.current === e.target) {
            setOnLogOut(!onLogOut);
        }
    };

    const signOut = () => {
        localStorage.clear();
        window.location.replace('/');
    };

    return (
        <>
            {onLogOut && (
                <div
                    ref={logOutModel}
                    onClick={handleRefClick}
                    className='bg-black/40 fixed inset-0  flex items-center justify-center z-50 bg-opacity-30'
                >
                    <div className='bg-white sm:w-[55%] mx-5 lg:w-[40%] 2xl:w-[26%] w-full text-black rounded-xl flex flex-col justify-center p-6'>
                        <div className='flex justify-between'>
                            <div>
                                <p className='text-[18px] font-medium mb-2'>Are you sure you want to log out?</p>
                                <p className='text-[#525154] font-normal text-[14px]'>You’ll need to sign in again to access your account.</p>
                            </div>
                            <img
                                className='size-5 mt-1 cursor-pointer' src={close} alt=""
                                onClick={() => setOnLogOut(false)}
                            />
                        </div>
                        <div className='flex justify-end gap-3 mt-12'>
                            <button
                                className='p-3 rounded-lg border-[1.2px] py-[10px] px-4 text-[14px] border-black/10'
                                onClick={() => setOnLogOut(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className='p-3 rounded-lg bg-[#FEEDED] text-[#EF4444] py-[10px] px-4 text-[14px]'
                                onClick={signOut}
                            >
                               Log Out
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ConfirmLogOut;
